import React, { createContext, useContext, useState, useMemo } from 'react'
import type { Stripe } from '@stripe/stripe-js'
import { StripeContextProps, StripeContextDefaultValues } from '@Interfaces/Data/StripeInterface'
import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const StripeContext = createContext<StripeContextProps>(StripeContextDefaultValues)

export const StripeProvider = ({ children }: ContextComponentProps) => {
  const [stripe, setStripe] = useState<Stripe | null>(null)

  const contextValue = useMemo(
    () => ({
      stripe,
      setStripe,
    }),
    [stripe]
  )

  return <StripeContext.Provider value={contextValue}>{children}</StripeContext.Provider>
}

export const useStripe = (): StripeContextProps => useContext(StripeContext)
